import React from 'react';
import {translations} from 'presentation/translations-new';
import {ConfirmationCard} from '../ConfirmationCard';
import {ProtocolCardProps} from './types';

const {protocolNumber: protocolNumberText} = translations['pt-br'].commons;

const {appointmentInstructions} =
	translations['pt-br'].privateFlow.myAppointments.myAppointmentDetails;

export function ProtocolCard({protocolNumber}: ProtocolCardProps) {
	if (!protocolNumber) {
		return null;
	}

	return (
		<ConfirmationCard.Root>
			<ConfirmationCard.Header subheader={appointmentInstructions.appointmentProtocol} />
			<ConfirmationCard.Content
				iconName={'assignment-filled'}
				primaryText={protocolNumberText}
				secondaryText={protocolNumber}
				secondaryTextColor="text.secondary"
			/>
		</ConfirmationCard.Root>
	);
}
